module.exports = __webpack_public_path__ + "img/it.d706d6f9.svg";